import { useUpdateEffect } from 'ahooks'
import { useFormContext as useReactFormContext } from 'react-hook-form'
import {
  UseFormReturn as UseReactFormReturn,
  FieldValues,
} from 'react-hook-form/dist/types'
import { Form, FormInstance } from 'components/common'

interface UseFormContextProps<TFieldValues> {
  form?: FormInstance<TFieldValues>
}

interface UseFormContextReturn<TFieldValues>
  extends UseReactFormReturn<TFieldValues, Record<string, unknown>> {
  form: FormInstance<TFieldValues>
}

export function useFormContext<TFieldValues extends FieldValues = FieldValues>(
  props: UseFormContextProps<TFieldValues> = {}
): UseFormContextReturn<TFieldValues> {
  const { watch, setError, clearErrors, ...rest } =
    useReactFormContext<TFieldValues>()
  const [form] = Form.useForm<TFieldValues>(props.form)

  useUpdateEffect(() => {
    const validate = async () => {
      try {
        clearErrors()
        await form.validateFields()
      } catch (e) {
        const { errorFields } = e
        errorFields?.forEach(({ name, errors }) => {
          for (const index in name) {
            setError(name[index], { message: errors[index] })
          }
        })
      }
    }

    validate()
  }, [watch()])

  // eslint-disable-next-line
  // @ts-ignore
  return {
    watch,
    setError,
    clearErrors,
    ...rest,
    form,
  }
}
